<template>
  <div class="line-items-drayage">
    <section
      class="lineitem-container"
      :id="'line-item' + index"
      v-for="(option, index) in selectedLineItems"
      :key="index"
    >
      <div class="lineitem-row">
        <div class="type-container lineitem-inputs">
          <RCSelect
            class="type-container__input"
            :class="{
              'missing-field': errors['type_container'],
              'disabled': disabled
            }"
            label="Type Container"
            v-model="option.type_container"
            :floatLabel="true"
            :requiredField="true"
            :suggestions="options"
            :key="renderKey"
          />
        </div>
        <ul class="weight lineitem-inputs"
          v-if="hasOverweight(accessorialsSelected)
          &&  selectedLineItems[0] && selectedLineItems[0].type_container !== '20'"
        >
          <li class="weight__input" >
            <RCInput
              :class="{
                'missing-field': errors['weight'],
                'disabled': disabled
              }"
              v-model="option.weight"
              :label="$t('allOptions.weight')"
              :floatLabel="true"
              :positiveNumbers="true"
              :requiredField="true"
              type="number"
            />
          </li>
          <li class="weight__dropdown">
            <RCSelect
              :class="{
                'missing-field': errors['weight_units'],
                'disabled': disabled
              }"
              v-model="option.weight_units"
              :suggestions="weight_units"
              :label="$t('allOptions.weightUnits')"
            />
          </li>
        </ul>
        <div class="description lineitem-inputs">
          <RCInput
          :class="{
              'missing-field': errors['description'],
              'disabled': disabled
            }"
            v-model="option.description"
            :label="$t('allOptions.commodity')"
            :floatLabel="true"
            :type="'text'"
            :requiredField="true"
          />
          <span class="commodity-excluded"
            >List of <u @click="openModalExcluded()"> excluded commodities</u></span
          >
        </div>
      </div>
    </section>
    <div class="alert-containers" v-if="!disabled">
      <el-alert
          v-if="!hasOverweight(accessorialsSelected) &&
          selectedLineItems[0] && selectedLineItems[0].type_container"
          type="warning"
          show-icon
          :closable="false"
        >
          <template #title>
            <b> Note:  </b>
            {{$t('myLoads.messageWeigthTypeContainer1')}}
            {{getMaxWeigth()}}
            <span v-if=" selectedLineItems[0] && selectedLineItems[0].type_container != '20'">
              {{$t('myLoads.messageWeigthTypeContainer2')}}
            </span>
          </template>
        </el-alert>
        <el-alert
          v-if="hasOverweight(accessorialsSelected) &&
         selectedLineItems[0] && selectedLineItems[0].type_container === '20'"
          type="error"
          show-icon
          :closable="false"
        >
          <template #title>
            <b> Action Restricted:  </b> {{$t('myLoads.messageNoQuoteDrayage')}}
          </template>
        </el-alert>
    </div>
    <div class="alert-containers" v-if="disabledAlertRail">
      <el-alert
        type="warning"
        show-icon
        :closable="false"
      >
        <template #title>
          <b> Important:  </b> {{$t('myLoads.messageRailDrayage')}}
        </template>
      </el-alert>
    </div>
    <CustomModal v-model="excludedModal" modalTitle="Excluded Commodities" centered size="lg">
      <template #modal-content>
        <ModalExcludedCommodities :quoteMode="'drayage'" />
      </template>
    </CustomModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isOverweight, getMaxWeightByContainerType } from "@/utils/DrayageDetails";
import CustomModal from "@/components/CustomModal.vue";
import LineItemDrayageSchema from "../../../schemas/LineItemsDrayageSchema";
import RCSelect from "../../../components/RCComponents/CustomRCSelect.vue";
import RCInput from "../../../components/RCComponents/CustomRCInput.vue";
import ModalExcludedCommodities from "../LoadCreation/lineItems/components/ModalExcludedCommodities.vue";

export default {
  name: "LineItemsDrayage",
  components: {
    RCSelect,
    RCInput,
    CustomModal,
    ModalExcludedCommodities
  },
  props: {
    lineItems: Array,
    disabled: Boolean,
    chosenLoad: Object,
    disabledAlertRail: Boolean,
    milesValue: Number
  },
  data() {
    return {
      selectedLineItems: [
        {
          type_container: null,
          weight_units: "lbs",
          weight: null,
          description: null,
        },
      ],
      errors: {
        type_container: false,
        weight_units: false,
        weight: false,
        description: false,
      },
      options: [
        { label: "20 ft", value: "20", id: 'a0V1I000000Hra8UAC' },
        { label: "40 ft", value: "40", id: 'a0V1I000000Hra6UAC' },
        { label: "45 ft", value: "45", id: 'a0V1I000000Hra4UAC' },
      ],
      weight_units: [
        { label: "lbs", value: "lbs" },
        { label: "kgs", value: "kgs" },
        { label: "ton", value: "ton" },
      ],
      renderKey: 0,
      excludedModal: false,
    };
  },
  computed: {
    ...mapGetters({
      accessorialsSelected: "load/accessorials/getChosenAccessorials",
    }),
  },
  watch: {
    selectedLineItems: {
      handler() {
        this.$emit("input", this.selectedLineItems);
      },
      deep: true,
      immediate: true,
    },
    lineItems: {
      handler(value) {
        this.assignLineItems(value);
        this.renderKey += 1;
      },
      deep: true,
      immediate: true,
    },
    accessorialsSelected: {
      handler(newVal, oldVal) {
        const hadOverweight = oldVal?.some((item) => item.name.toLowerCase() === "overweight");
        const hasOverweight = newVal?.some((item) => item.name.toLowerCase() === "overweight");
        if (hadOverweight && !hasOverweight) {
          this.selectedLineItems[0].weight = null;
        }
      },
      deep: true,
      immediate: false
    }
  },
  created() {
    this.assignLineItems(this.lineItems);
  },
  methods: {
    updateLoadLineItems() {
      return [Promise.resolve()];
    },
    async validateFormfields() {
      let validateForm;
      this.errors = {
        type_container: false,
        weight_units: false,
        weight: false,
        description: false,
      };
      try {
        this.selectedLineItems[0].overweigth = this.hasOverweight(this.accessorialsSelected);
        if (!this.selectedLineItems[0].overweigth) {
          this.selectedLineItems[0].weight = getMaxWeightByContainerType(this.selectedLineItems[0].type_container);
        }
        await LineItemDrayageSchema.validate(this.selectedLineItems[0], {
          abortEarly: false,
        });
        validateForm = true;
      } catch (error) {
        validateForm = false;
        error.inner.forEach((element) => {
          this.errors[element.path] = true;
        });
      }
      return validateForm;
    },
    assignLineItems(lineItems) {
      if (lineItems && lineItems.length > 0) {
        this.selectedLineItems = lineItems.map((item) => {
          const foundOption = this.options.find((option) => option.id === this.chosenLoad?.equipment_type?.id);
          return {
            ...item,
            type_container: foundOption ? foundOption.value : null
          };
        });
      }
    },
    updateLineItemsToLoad() {
      const lineItemsRequests = [];
      const chosenLoad = this.$store.getters["load/getChosenLoad"];
      this.selectedLineItems.forEach((item, index) => {
        const typeContainer = item.type_container;
        const payload = {
          id: this.$route.params.loadId,
          lineItemId: item.line_item_id,
          body: item,
        };
        this.removeUnusedProperties(item);
        const itemValidation = this.validateItemsForUpdates(
          chosenLoad.line_items,
          this.selectedLineItems[index]
        );
        if (itemValidation) {
          if (this.$options.filters.checkPermission("patch:line-item")) {
            lineItemsRequests.push(
              this.$store.dispatch("load/lineItems/updatedLineItem", payload)
            );
          }
        }
        this.selectedLineItems[index].type_container = typeContainer;
      });
      return lineItemsRequests;
    },
    removeUnusedProperties(item) {
      delete item.density;
      delete item.linear_feet;
      delete item.nmfc_number;
      delete item.type_container;
    },
    getMaxWeigth() {
      return `(${getMaxWeightByContainerType(this.selectedLineItems[0]?.type_container)} lbs).`;
    },
    /*
      validate if the chosen load and selected line items
      have changes and validate if is necessary dispatch the function to update.
    */
    validateItemsForUpdates(chosenLoadLineItems, item) {
      const foundItem = chosenLoadLineItems.find(
        (lineItem) => lineItem.line_item_id === item.line_item_id
      );
      let itemWasModified = false;
      if (foundItem) {
        const keys = Object.keys(item);
        keys.forEach((key) => {
          // eslint-disable-next-line eqeqeq
          if (item[key] != foundItem[key]) {
            itemWasModified = true;
          }
          return null;
        });
      }
      return itemWasModified;
    },
    hasOverweight(accessorials) {
      return isOverweight(accessorials);
    },
    openModalExcluded() {
      this.excludedModal = true;
    },

  },
};
</script>

<style lang="scss" scoped>
@use "../../../assets/scss/components/RCComponents.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
.lineitem-row {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  @media (max-width: 650px) {
    flex-wrap: wrap;
    gap: 20px;
  }
}

.type-container {
  flex-basis: 23%;
  @media (max-width: 860px) {
    flex-basis: 30%;
  }
  @media (max-width: 650px) {
    flex-basis: 100%;
  }
}

::v-deep .el-alert--warning.is-light {
    background-color: #FFE1B3;
    color: $color-primary-title;
}

::v-deep .weight {
  @include remove-custom-component-styles;
  display: flex;
  flex-basis: 30%;
  list-style-type: none;
  border-radius: 10px;
  @media (max-width: 860px) {
    flex-basis: 30%;
  }
  @media (max-width: 650px) {
    flex-basis: 100%;
  }
  &__input {
    @include hide-input-number-arrows;
    width: 70%;
    & .rc-input-container {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  &__dropdown {
    width: 30%;
    & .rc-select-container {
      border-left: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
}

.lineitem-inputs {
  margin: 0px 5px 0px 0px;
  height: 42px;
  & li {
    &:first-child {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  }
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.description {
  flex-basis: 100%;
}
.alert-containers{
  display: flex;
  justify-content: start;
  margin-top: 20px
}
::v-deep .el-alert__content {
  display: flex ;
  margin-left: 5px;
  padding: 0px;
}
.commodity-excluded {
  display: flex;
  justify-content: flex-start;
  margin-top: 5px;
  cursor: pointer;
  font-size: 12px;
  font-style: italic;
  font-family: "Montserrat";
  u {
    margin-left: 5px;
  }
}
</style>
